import React from 'react';

// 🚀 Componente memoizado para evitar re-renders innecesarios
const ProductItem = React.memo(({
  product,
  isInCart,
  onAddToCart,
  onRemoveFromCart
}) => {
  const discountedPrice = product.discount && product.discount > 0
    ? (product.price - (product.price * product.discount) / 100).toFixed(2)
    : product.discountInPesos && product.discountInPesos > 0
    ? (product.price - product.discountInPesos).toFixed(2)
    : null;

  return (
    <div key={product.id} className="product-item">
      {/* Badge de descuento */}
      {product.discount > 0 ? (
        <div className="discount-badge">{product.discount}% OFF</div>
      ) : product.discountInPesos > 0 ? (
        <div className="discount-badge">${product.discountInPesos} OFF</div>
      ) : null}

      <img src={product.image} alt={product.name} className="product-image" />
      <div className="product-details">
        <h2>{product.name}</h2>
        <p>{product.description}</p>
        
        {discountedPrice ? (
          <>
            <p className="product-original-price">
              <del>Precio: ${product.price}</del>
            </p>
            <p className="product-discounted-price">
              Precio: ${discountedPrice}
            </p>
          </>
        ) : (
          <p>Precio: ${product.price}</p>
        )}

        {isInCart ? (
          <button
            className="remove-from-cart-button"
            onClick={() => onRemoveFromCart(product.id)}
          >
            Quitar del carrito
          </button>
        ) : (
          <button
            className="add-to-cart-button"
            onClick={() => onAddToCart(product)}
            disabled={product.stock <= 0}
          >
            {product.stock > 0 ? 'Agregar al carrito' : 'Sin stock'}
          </button>
        )}
      </div>
    </div>
  );
}, (prevProps, nextProps) => {
  // Retornar true = NO re-renderizar, false = re-renderizar
  // Solo re-render si estos valores cambian
  const shouldSkipRender = (
    prevProps.product.id === nextProps.product.id &&
    prevProps.product.price === nextProps.product.price &&
    prevProps.product.stock === nextProps.product.stock &&
    prevProps.isInCart === nextProps.isInCart
  );
  return shouldSkipRender;
});

ProductItem.displayName = 'ProductItem';

export default ProductItem;
